import { type ImageFormat, type ImageTransform } from '@sr/types/content/image';
import { type ImageDimensions, type ImageVariant } from './resolveImageSizes';

export const getVariantUrl = (
  src: string,
  { width, height }: ImageDimensions,
  format: ImageFormat,
  quality: NonNullable<ImageTransform['quality']>,
  fit: ImageTransform['fit'],
) => {
  const url = new URL(src);

  if (width !== undefined) {
    url.searchParams.set('width', String(width));
  }
  if (height !== undefined) {
    url.searchParams.set('height', String(height));
  }
  if (fit !== undefined) {
    url.searchParams.set('fit', fit);
  }

  url.searchParams.set('format', format);
  url.searchParams.set('quality', String(quality));

  return url.toString();
};

export const getSrcSet = (
  src: string,
  variants: readonly ImageVariant[],
  format: ImageFormat,
  quality: NonNullable<ImageTransform['quality']>,
  fit: ImageTransform['fit'],
) =>
  variants
    .map(
      ({ size, descriptor }) => `${getVariantUrl(src, size, format, quality, fit)} ${descriptor}`,
    )
    .join(', ');
